// Golf 6b (builder U) in de ouder-webapp: Vandaag als widgets (a.home.*), de agendaweergaven met
// werkweek, pijltjes, sneltoetsen en vegen (a.agendaViews.*) en het weerdetail met het verloop per
// uur (a.weatherDetail.*). Je-vorm, kort, rustig (docs/DESIGN.md §2). Het weerdetail noemt nooit
// gebed of moskee (neutraal, zoals het hele weer).
export const appHomeNl = {
    customize: 'Aanpassen',
    customizeLabel: 'Vandaag aanpassen',
    done: 'Klaar',
    intro: 'Zet op Vandaag wat jij belangrijk vindt. Sleep een kaart naar een andere plek, maak hem groter of kleiner aan de rand of de hoek, of kies S, M of L.',
    /** Telefoon: alleen de volgorde (feat/vandaag-raster). */
    introList: 'Zet de kaarten in de volgorde die jij wilt: sleep aan het greepje of gebruik de pijltjes. Op een groter scherm kun je ze ook vrij plaatsen en groter of kleiner maken.',
    undo: 'Ongedaan maken',
    undone: 'De laatste wijziging is ongedaan gemaakt.',
    /** Raster (computer en tablet): zoals de bord-editor. */
    gridHint: 'Raster van Vandaag: sleep een kaart naar een andere plek, trek aan de rand of de hoek om hem kleiner of groter te maken.',
    cardAt: '{name}, {w} bij {h} vakken, kolom {x}, rij {y}',
    keysHint: 'Pijltjes: verplaatsen. Shift en pijltjes: kleiner of groter.',
    noRoom: 'Past hier niet. Maak eerst iets kleiner of haal iets weg.',
    size: 'Maat',
    sizes: { S: 'Klein', M: 'Middel', L: 'Groot' },
    /** Geen scroll in kaarten (6 okt): wat niet past, staat achter één regel naar de pagina. */
    fitMore: '+{count} meer',
    fitMoreAll: 'Meer bekijken',
    reset: 'Standaard terugzetten',
    resetDone: 'Vandaag staat weer zoals eerst.',
    saveFailed: 'Opslaan lukte niet. Probeer het zo opnieuw.',
    add: 'Kaart toevoegen',
    addTitle: 'Kaart toevoegen',
    addNothing: 'Alle kaarten staan er al op.',
    moveUp: '{name} omhoog',
    moveDown: '{name} omlaag',
    remove: '{name} weghalen',
    removed: '{name} is weggehaald.',
    added: '{name} staat nu op Vandaag.',
    drag: '{name} verslepen',
    /** Voor schermlezers na een verplaatsing. */
    position: '{name} staat nu op plek {pos} van {count}.',
    empty: 'Vandaag is nog leeg.',
    emptyBody: 'Tik op Aanpassen en kies wat je hier wilt zien.',
    emptyEdit: 'Nog geen kaarten. Voeg er hieronder een toe.',
    /** In Aanpassen: een kaart die nu niets laat zien. */
    quiet: 'Nu niets te zien. De kaart verschijnt vanzelf als er iets is.',
    widgets: {
        now: { name: 'Nu bezig', description: 'Wat nu bezig is of straks begint' },
        agenda: { name: 'Agenda vandaag', description: 'Alle afspraken van vandaag' },
        tasks: { name: 'Taken vandaag', description: 'Hoe ver iedereen is met zijn taken' },
        tomorrow: { name: 'Morgen', description: 'Een blik op de afspraken van morgen' },
        weather: { name: 'Weer', description: 'Weer en kledingadvies, tik voor meer' },
        rides: { name: 'Ritten', description: 'Ritten waar nog niemand voor rijdt' },
        prayer: { name: 'Gebedstijden', description: 'De tijden van vandaag' },
        check_in: { name: 'Dagelijkse check-in', description: "Of 'Alles goed' er vandaag is" },
        goals: { name: 'Sparen', description: 'Hoe ver de kinderen zijn met sparen' },
        shopping: { name: 'Boodschappen', description: 'Wat er nog gehaald moet worden' },
        messages: { name: 'Berichten', description: 'Nieuwe berichten van het gezin' },
        wishes: { name: 'Wensen', description: 'De wensen van de kinderen' },
        rotation: { name: 'Beurtrooster', description: 'Wie wat doet deze week en wie vandaag kookt' },
        // Golf 8 (0049): Samen wonen.
        dinner: { name: 'Vanavond eten', description: 'Wie er mee-eet en jouw keuze' },
        bookings: { name: 'Reserveren', description: 'Jouw volgende reservering en wat er vrij is' },
        balance: { name: 'Kosten', description: 'Alleen jouw eigen saldo' },
        // 0069: Geldzaken (alleen in je eigen omgeving).
        money: { name: 'Geldzaken', description: 'Wat er deze maand overbleef (alleen jij)' },
        todos: { name: "To-do's", description: "Je open to-do's, met uiterlijk" },
        // 0076: schoolplanner.
        school: {
            name: 'Huiswerk en toetsen',
            description: 'Huiswerk van vandaag, toetsen die eraan komen en cijfers om in te voeren',
        },
        // 0075: Huisronde (module Eten).
        house_round: { name: 'Huisronde', description: 'De volgende ronde door het huis, en starten' },
    },
    shopping: {
        open: { one: '{count} ding te halen', other: '{count} dingen te halen' },
        empty: 'Alles is gehaald.',
        all: 'Naar de boodschappen',
        more: '+{count} meer',
    },
    messages: {
        unread: { one: '{count} nieuw bericht', other: '{count} nieuwe berichten' },
        none: 'Geen nieuwe berichten.',
        all: 'Naar berichten',
        voice: 'Spraakbericht',
        sticker: 'Sticker',
        pictos: 'Plaatjes',
    },
    wishes: {
        count: { one: '{count} wens', other: '{count} wensen' },
        empty: 'Nog geen wensen.',
        all: 'Naar de wensen',
    },
    /** Golf 6b fixer r1: widget Beurtrooster (huisgenoten). */
    rotation: {
        you: 'Jij deze week',
        done: 'Gedaan',
        open: 'Nog te doen',
        noneForYou: 'Deze week heb jij geen beurt.',
        cooks: '{name} kookt vandaag',
        youCook: 'Jij kookt vandaag',
        others: 'De rest van het huis',
        all: 'Naar het rooster',
        empty: 'Nog geen beurtrooster.',
    },
    prayer: {
        next: 'Hierna',
        settings: 'Instellingen',
        fromTable: 'Uit het rooster van je moskee',
    },
};
export const appAgendaViewsNl = {
    day: 'Dag',
    workweek: 'Werkweek',
    week: 'Week',
    month: 'Maand',
    workweekTitle: 'Werkweek {week} · {range}',
    emptyWorkweek: 'Nog niets gepland deze werkweek',
    prev: {
        day: 'Vorige dag',
        workweek: 'Vorige werkweek',
        week: 'Vorige week',
        month: 'Vorige maand',
    },
    next: {
        day: 'Volgende dag',
        workweek: 'Volgende werkweek',
        week: 'Volgende week',
        month: 'Volgende maand',
    },
    keys: 'Sneltoetsen: ← en → om te bladeren, T voor vandaag.',
};
export const appWeatherDetailNl = {
    open: 'Meer over het weer',
    titleToday: 'Het weer vandaag',
    titleTomorrow: 'Het weer morgen',
    today: 'Vandaag',
    tomorrow: 'Morgen',
    temp: 'Temperatuur',
    tempRange: '{min}° tot {max}°',
    feels: 'Gevoelstemperatuur',
    feelsRange: '{min}° tot {max}°',
    feelsDay: 'overdag rond {value}°',
    rain: 'Regen',
    rainChance: {
        dry: 'Droog',
        small: 'Kleine kans op een bui',
        likely: 'Kans op regen',
        wet: 'Regenachtig',
    },
    rainAmount: '{mm} mm',
    rainHours: { one: 'in {count} uur', other: 'in {count} uur' },
    rainWhen: 'tussen {from} en {until}',
    rainPct: 'kans {pct}%',
    rainNoPct: 'Voor Nederland geeft MET Norway geen kans in procenten. Dit is wat er volgens de verwachting valt.',
    wind: 'Wind',
    windForce: 'Windkracht {bft}',
    windFrom: 'uit het {dir}',
    windSpeed: '{kmh} km/u',
    /** Namen van het KNMI per Beaufort (0 t/m 12). */
    bft: [
        'windstil',
        'zwak',
        'zwak',
        'zwak',
        'matig',
        'vrij krachtig',
        'krachtig',
        'hard',
        'stormachtig',
        'storm',
        'zware storm',
        'zeer zware storm',
        'orkaan',
    ],
    dirs: {
        N: 'noorden',
        NE: 'noordoosten',
        E: 'oosten',
        SE: 'zuidoosten',
        S: 'zuiden',
        SW: 'zuidwesten',
        W: 'westen',
        NW: 'noordwesten',
    },
    dirShort: { N: 'N', NE: 'NO', E: 'O', SE: 'ZO', S: 'Z', SW: 'ZW', W: 'W', NW: 'NW' },
    uv: 'Zonkracht',
    uvLevels: {
        low: 'laag',
        moderate: 'matig',
        high: 'hoog',
        very_high: 'zeer hoog',
        extreme: 'extreem',
    },
    uvValue: 'UV {value}, {level}',
    uvClearSky: 'bij heldere lucht',
    sun: 'Zon',
    sunrise: 'Op {time}',
    sunset: 'Onder {time}',
    course: 'Verloop van de dag',
    courseOpen: 'Verloop per uur',
    back: 'Terug',
    courseTemp: 'Temperatuur (°C)',
    courseRain: 'Neerslag (mm per uur)',
    courseHour: '{time}: {temp}°, {rain} mm, windkracht {bft}',
    partial: 'Nog niet alle uren van deze dag zijn bekend.',
    now: 'Nu',
    close: 'Sluiten',
    symbols: {
        clear: 'zonnig',
        partly_cloudy: 'half bewolkt',
        cloudy: 'bewolkt',
        fog: 'mist',
        drizzle: 'motregen',
        rain: 'regen',
        heavy_rain: 'zware regen',
        sleet: 'natte sneeuw',
        snow: 'sneeuw',
        thunder: 'onweer',
    },
};
//# sourceMappingURL=homeApp.nl.js.map